
import React from "react";
import ReactTooltip from "react-tooltip";
import { mainSelectedTab } from "../atoms";
import { CarrierAgreementMgmtTabs } from "../carrierAgreementTabs";
import { useRecoilState, useRecoilValue } from "recoil";
import {  useHistory } from "react-router-dom";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { employeeFromProdCodeRow } from "../Employees/Confie/atoms/atoms";
import { PERMISSIONS } from "../../PermissionsConstants";



const ProducerCodeExpandedRow = ({ data }) => {

  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const viewPermissionEmp = 
    PERMISSIONS.permission_carrieragreemnentmgmt_employee_view;

  const [viewFromProduceCode, setViewFromProduceCode] = useRecoilState(employeeFromProdCodeRow);

  
  const handlelink = (moduleName, producer) => {
    const url = "/carrieragreementmgmt/employee";
    history.push({
      pathname: `/carrieragreementmgmt/employee?actionFrom=ProducerCodeRow&employeenumber=${data.producer}`,
                  });
                  let userTabs = [
                    {
                      to: "",
                    },
                  ];
                  [...CarrierAgreementMgmtTabs].forEach((tabs) => {
                    let temp = [...userPermissions].filter(
                      (user) => user === tabs.permission
                    );
                    if (temp.length > 0) userTabs.push(tabs);
                  });
                  userTabs.shift();
                  const index = userTabs.findIndex((c) => c.to === url);
                  setViewFromProduceCode(true)
                  setSelectedIndex(index)
  };

  return (
    <div className="w-full">
      <div className="p-2 space-y-4 mb-2 border-quinary">
        <div className="text-xs font-medium ">
          <div className="grid grid-flow-col grid-cols-3 gap-12 m-2">
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">Agency:</div>
              <div className="expandedData fontExpand">
                {" "}
                {data.brand ? (
                  data.brand
                ) : (
                  <span className="undefineTextColor">unspecified</span>
                )}
              </div>
            </div>
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">
                Code Level:
              </div>
              <div className="expandedData fontExpand">
                {data.codeLevel ? (
                  data.codeLevel
                ) : (
                  <span className="undefineTextColor">unspecified</span>
                )}
              </div>
            </div>
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">
                Is Active:
              </div>
              <div className="expandedData fontExpand">
                {data.isActive ? "True" : "False"}
              </div>
            </div>
          </div>
          <div className="w-full border-b border-gray-200" />
          <div className="grid grid-flow-col grid-cols-3 gap-12 m-2">
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">
                Sub Code:
              </div>
              <div className="expandedData fontExpand">
                {" "}
                {data.producerSubCodes ? (
                  data.producerSubCodes
                ) : (
                  <span className="undefineTextColor">unspecified</span>
                )}
              </div>
            </div>
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">
                Carrier Program Name:
              </div>
              <div className="expandedData fontExpand">
                {data.program ? (
                  data.program
                ) : (
                  <span className="undefineTextColor">unspecified</span>
                )}
              </div>
            </div>
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">MGA:</div>
              <div className="expandedData fontExpand">
                {data.mga ? (
                  data.mga
                ) : (
                  <span className="undefineTextColor">unspecified</span>
                )}
              </div>
            </div>
          </div>
          <div className="w-full border-b border-gray-200" />
          <div className="grid grid-flow-col grid-cols-3 gap-12 m-2">
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">M&A:</div>

              <div className="expandedData fontExpand truncate">
                {data.mAproducerCodes ? (
                  data.mAproducerCodes
                ) : (
                  <span className="undefineTextColor">unspecified</span>
                )}
              </div>
            </div>
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">
                Distribution Channel:
              </div>

              <div className="expandedData fontExpand truncate">
                {data.distributionChannelName ? (
                  data.distributionChannelName
                ) : (
                  <span className="undefineTextColor">unspecified</span>
                )}
              </div>
            </div>
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">
                Issued To:
              </div>
              <ReactTooltip
                className="w-1/2"
                place="bottom"
                effect="solid"
                type="info"
              />{" "}
              <div
                className="expandedData fontExpand truncate"
                data-tip={data.issuedTo}
              >
                {data.issuedTo ? (
                  data.issuedTo
                ) : (
                  <span className="undefineTextColor">unspecified</span>
                )}
              </div>
            </div>
          </div>
          <div className="w-full border-b border-gray-200" />
          <div className="grid grid-flow-col grid-cols-3 gap-12 m-2">
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">
                Office Code:
              </div>
              <div className="expandedData fontExpand">
                {" "}
                {data.officeCode ? (
                  data.officeCode
                ) : (
                  <span className="undefineTextColor">unspecified</span>
                )}
              </div>
            </div>
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">
                Store Number:
              </div>
              <div className="expandedData fontExpand">
                {" "}
                {data.storeNumber ? (
                  data.storeNumber
                ) : (
                  <span className="undefineTextColor">unspecified</span>
                )}
              </div>
            </div>
            {data.associatedTo === "Office" ? (
              <div className="grid grid-cols-2 ">
                <div className="expandedLabel fontExpand text-left">
                  Associated To:
                </div>
                <div className="expandedData fontExpand">
                  {data.officeName ? (
                    <div>
                      {data.officeName}
                      <div className="text-xxs text-black-400">
                        {data.address}
                        {", "} {data.city}
                        {", "} {data.state}
                        {", "} {data.zipCode}{" "}
                      </div>{" "}
                    </div>
                  ) : (
                    <span className="undefineTextColor">unspecified</span>
                  )}
                </div>
              </div>
            ) : (
              <div className="grid grid-cols-2 ">
                <div className="expandedLabel fontExpand text-left">
                  Producer:
                </div>
                <div className="expandedData fontExpand">
                <ReactTooltip place='right'effect="solid" type="info" />
                {userPermissions.includes(viewPermissionEmp) ? (
              data.producerName !== "" ? (
                <div
                className="cursor-pointer" onClick={() => {
                  handlelink("employee", data.producer)
                }}
              >
                <span className=" font-bold-400 uppercase">
                  <span className="blueAndBold underline uppercase">{data.producerName}</span>
                </span>
                 </div>
              ) : (
                <span className="undefineTextColor">unspecified</span>
              ) 
              ): (
                data.producerName !== "" ?(
                <div
                  data-tip={
                    "Contact your System Administrator to secure access to employee module."
                  }
                  className="cursor-pointer"
                >
                  <span>
                    {data.producerName}
                  </span>
                </div>
                ) : (
                  <span className="undefineTextColor">unspecified</span>
                ) 
              )}
                </div>
              </div>
            )}{" "}
          </div>
          <div className="w-full border-b border-gray-200" />
          <div className="grid grid-flow-col grid-cols-3 gap-12 m-2">
            {" "}
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">
                Master Code Status:
              </div>
              <div className="expandedData fontExpand">
                {" "}
                {data.masterCodeStatus ? "Active" : "Inactive"}
              </div>
            </div>
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">
                Roll Up Code Status:
              </div>
              <div className="expandedData fontExpand">
                {" "}
                {data.rollUpCodeStatus ? "Active" : "Inactive"}
              </div>
            </div>{" "}
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">
                State Code:
              </div>
              <div className="expandedData fontExpand">
                {" "}
                {data.state ? (
                  data.state
                ) : (
                  <span className="undefineTextColor">unspecified</span>
                )}
              </div>
            </div>
          </div>
          <div className="w-full border-b border-gray-200" />
          <div className="grid grid-flow-col grid-cols-3 gap-12 m-2">
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">
                Master Code:
              </div>
              <div className="expandedData fontExpand">
                {data.masterCode ? (
                  data.masterCode
                ) : (
                  <span className="undefineTextColor">unspecified</span>
                )}
              </div>
            </div>
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">
                Roll Up Codes:
              </div>
              <div className="expandedData fontExpand">
                {data.rollUpCode ? (
                  data.rollUpCode
                ) : (
                  <span className="undefineTextColor">unspecified</span>
                )}
              </div>
            </div>
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">
                Can Sell:
              </div>
              <div className="expandedData fontExpand">
                {" "}
                {data.crossSale ? (
                  data.crossSale
                ) : (
                  <span className="undefineTextColor">unspecified</span>
                )}
              </div>
            </div>
          </div>
          <div className="w-full border-b border-gray-200" />
          <div className="grid grid-flow-col grid-cols-3 gap-12 m-2">
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">
                Created By:
              </div>
              <div className="expandedData fontExpand">
                {" "}
                {data.createdBy ? (
                  data.createdBy
                ) : (
                  <span className="undefineTextColor">unspecified</span>
                )}
              </div>
            </div>
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">
                Created Date:
              </div>
              <div className="expandedData fontExpand">
                {data.createdDate ? (
                  new Date(data.createdDate).toLocaleDateString() +
                  " " +
                  new Date(data.createdDate).toLocaleTimeString(
                    navigator.language,
                    { hour: "2-digit", minute: "2-digit" }
                  )
                ) : (
                  <span className="undefineTextColor">unspecified</span>
                )}
              </div>
            </div>
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">
                Modified By:
              </div>
              <div className="expandedData fontExpand">
                {" "}
                {data.modifiedBy ? (
                  data.modifiedBy
                ) : (
                  <span className="undefineTextColor">unspecified</span>
                )}{" "}
              </div>
            </div>
          </div>
          <div className="w-full border-b border-gray-200" />
          <div className="grid  grid-flow-col grid-cols-3 gap-12 m-2">
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">
                Modified Date:
              </div>
              <div className="expandedData fontExpand">
                {data.modifiedDate ? (
                  new Date(data.modifiedDate).toLocaleDateString() +
                  " " +
                  new Date(data.modifiedDate).toLocaleTimeString(
                    navigator.language,
                    { hour: "2-digit", minute: "2-digit" }
                  )
                ) : (
                  <span className="undefineTextColor">unspecified</span>
                )}
              </div>
            </div>
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">
                Mapped To CDRC:
              </div>
              <div className="expandedData fontExpand">
                {data.mappedToCdrc ? "True" : "False"}
              </div>
            </div>
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">
                Mapped To Keeper:
              </div>
              <div className="expandedData fontExpand">
                {data.mappedToKeeper ? "True" : "False"}
              </div>
            </div>
          </div>
          <div className="w-full border-b border-gray-200" />
          <div className="grid  grid-flow-col grid-cols-3 gap-12 m-2">
            <div className="grid grid-cols-2 ">
              <div className="expandedLabel fontExpand text-left">
                Acquisition Name:
              </div>
              <div className="expandedData fontExpand">
                {data.acquisitionName ? (
                  data.acquisitionName
                ) : (
                  <span className="undefineTextColor">unspecified</span>
                )}
              </div>
            </div>
            {data.carrierName === "National General" && (
              <>
                <div className="grid grid-cols-2 ">
                  <div className="expandedLabel fontExpand text-left">
                    Princeton Agent Code:
                  </div>
                  <div className="expandedData fontExpand">
                    {data.princetonAgentCode ? (
                      data.princetonAgentCode
                    ) : (
                      <span className="undefineTextColor">unspecified</span>
                    )}
                  </div>
                </div>
                <div className="grid grid-cols-2 ">
                  <div className="expandedLabel fontExpand text-left">
                    Master Agent Princeton ID:
                  </div>
                  <div className="expandedData fontExpand">
                    {data.masterAgentPrincetonId ? (
                      data.masterAgentPrincetonId
                    ) : (
                      <span className="undefineTextColor">unspecified</span>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProducerCodeExpandedRow;
